import React, { createContext, useReducer } from "react";
import {
  VSAContextActions,
  VSAContextReducer,
  VSA_DEFAULT_VALUE,
} from "../reducers/vsa-context-reducer";

export const VSAContext = createContext();

const VSAContextProvider = (props) => {
  const [vsaState, dispatchVSA] = useReducer(
    VSAContextReducer,
    VSA_DEFAULT_VALUE
  );

  const updateVehicleInspectionDetails = (details) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS,
      value: details,
    });
  };

  const updateVehicleInspectionDetailsResponse = (response) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS_RESPONSE,
      value: response,
    });
  };

  const updateCertifyRepairsResponse = (response) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_CERTIFY_REPAIRS_RESPONSE,
      value: response,
    });
  };

  const updateSubmitInspectionReportResponse = (response) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_SUBMIT_INSPECTION_REPORT_RESPONSE,
      value: response,
    });
  };

  const destructureVehicleInspectionDetails = (
    vehicleInspectionDetails,
    vin
  ) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_TEMPLATE,
      value: vehicleInspectionDetails.inspectionTemplate,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_ISSUES,
      value: vehicleInspectionDetails.issues,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_DATA,
      value: vehicleInspectionDetails.vehicleData,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VIN,
      value: vin,
    });
  };

  const updateReport = (report) => {
    dispatchVSA({ type: VSAContextActions.UPDATE_REPORT, value: report });
  };

  const updateReportThumbnails = (report) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_REPORT_THUMBNAILS,
      value: report,
    });
  };

  const incrementMoveToLocationIndex = () => {
    dispatchVSA({ type: VSAContextActions.INCREMENT_MOVE_TO_LOCATION_INDEX });
  };

  const decrementMoveToLocationIndex = () => {
    dispatchVSA({ type: VSAContextActions.DECREMENT_MOVE_TO_LOCATION_INDEX });
  };

  const updateMoveToLocationIndex = (value) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_MOVE_TO_LOCATION_INDEX,
      value: value,
    });
  };

  const incrementCurrentCategoryIndex = () => {
    dispatchVSA({ type: VSAContextActions.INCREMENT_CURRENT_CATEGORY_INDEX });
  };

  const decrementCurrentCategoryIndex = () => {
    dispatchVSA({ type: VSAContextActions.DECREMENT_CURRENT_CATEGORY_INDEX });
  };

  const updateCurrentCategoryIndex = (value) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_CURRENT_CATEGORY_INDEX,
      value: value,
    });
  };

  const resetCurrentCategoryIndex = () => {
    dispatchVSA({ type: VSAContextActions.RESET_CURRENT_CATEGORY_INDEX });
  };

  const clearData = () => {
    //TODO: MAKE SURE TO UPDATE FUNCTION AS NEW DATA IS INCLUDED
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS_RESPONSE,
      value: "",
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS,
      value: "",
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_INSPECTION_TEMPLATE,
      value: "",
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_ISSUES,
      value: "",
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VEHICLE_DATA,
      value: "",
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_VIN,
      value: "",
    });
    dispatchVSA({ type: VSAContextActions.UPDATE_REPORT, value: "" });
    dispatchVSA({
      type: VSAContextActions.UPDATE_REPORT_THUMBNAILS,
      value: "",
    });
  };

  const updateCurrentTakePhotoChecklistItem = (value) => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM,
      value: value,
    });
  };

  const resetCurrentTakePhotoChecklistItem = () => {
    dispatchVSA({
      type: VSAContextActions.RESET_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM,
    });
  };

  const setInspectionStartTime = () => {
    dispatchVSA({ type: VSAContextActions.SET_INSPECTION_START_TIME });
  };

  const resetVSAInspection = () => {
    dispatchVSA({
      type: VSAContextActions.UPDATE_MOVE_TO_LOCATION_INDEX,
      value: 0,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_INSPECTION_CURRENT_STEPS_COUNT,
      value: 0,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_INSPECTION_TOTAL_STEPS_COUNT,
      value: 0,
    });
    dispatchVSA({
      type: VSAContextActions.UPDATE_CURRENT_CATEGORY_INDEX,
      value: 0,
    });
  };

  return (
    <VSAContext.Provider
      value={{
        vsaState,
        vsaActions: {
          updateVehicleInspectionDetails,
          updateVehicleInspectionDetailsResponse,
          updateCertifyRepairsResponse,
          updateSubmitInspectionReportResponse,
          destructureVehicleInspectionDetails,
          updateReport,
          updateReportThumbnails,
          incrementMoveToLocationIndex,
          decrementMoveToLocationIndex,
          updateMoveToLocationIndex,
          incrementCurrentCategoryIndex,
          decrementCurrentCategoryIndex,
          updateCurrentCategoryIndex,
          resetCurrentCategoryIndex,
          clearData,
          updateCurrentTakePhotoChecklistItem,
          resetCurrentTakePhotoChecklistItem,
          setInspectionStartTime,
          resetVSAInspection,
        },
      }}
    >
      {props.children}
    </VSAContext.Provider>
  );
};

export default VSAContextProvider;
